import type { FlightFilterState } from '@aviata/offers-filters-fns';
import { DAY_IN_MINUTES } from './config';

export const minutesToHours = (minutes: number) => minutes / 60;
export const hoursToMinutes = (hours: number) => hours * 60;

// TODO: add tests
const hasSelectedTimeFilter = ([fromTime, toTime]: Array<number>) => {
  const { start, end } = DAY_IN_MINUTES;
  return fromTime !== start || toTime !== end;
};

const getFlightNumberOfSelectedTimeFilter = (flight: FlightFilterState) => {
  const { dep, arr } = flight;
  return [dep, arr]
    .map(({ time }) => hasSelectedTimeFilter(time))
    .reduce((acc, isSelected) => (isSelected ? acc + 1 : acc), 0);
};

export const getNumberOfSelectedTimeFilter = (
  flights: Array<FlightFilterState>,
) =>
  flights
    .map(getFlightNumberOfSelectedTimeFilter)
    .reduce((acc, numberOfSelected) => (acc += numberOfSelected), 0);
